module.exports = __webpack_public_path__ + "static/media/2023_3.fb859559.jpg";